export const GET_BUSINESS_PROFILES = 'GET_BUSINESS_PROFILES';
export const SET_BUSINESS_PROFILES = 'SET_BUSINESS_PROFILES';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_BUSINESS_PROFILE = 'SET_BUSINESS_PROFILE';
export const ADD_BUSINESS_PROFILE = 'ADD_BUSINESS_PROFILE';
export const EMPTY_BUSINESS_PROFILE = 'EMPTY_BUSINESS_PROFILE';
export const DELETE_BUSINESS_PROFILE = 'DELETE_BUSINESS_PROFILE';
export const EDIT_BUSINESS_PROFILE = 'EDIT_BUSINESS_PROFILE';
export const UPDATE_BUSINESS_PROFILE = 'UPDATE_BUSINESS_PROFILE';
export const SET_BUSINESS_PROFILE_FILTER = 'SET_BUSINESS_PROFILE_FILTER';